let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7WaUI"), load("hhss7"), load("gV84f")]).then(() => parcelRequire('7SmYm'));